<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <riden-logo />

          <h2 class="brand-text text-primary ml-1">
            Petra Ride
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Administrator Dashboard
        </b-card-title>
        <b-card-text class="mb-2">
          Sign in with Federated Identity providers
        </b-card-text>

        <!-- form -->
        <validation-observer
          v-if="false"
          ref="loginValidation"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >
            <!-- username -->
            <b-form-group
              label="Username"
              label-for="login-username"
            >
              <b-form-input
                id="login-username"
                v-model="username"
                name="login-username"
                placeholder="john"
              />
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="login-password"
                    v-model="password"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="login-password"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit buttons -->
            <b-button
              type="submit"
              class="mb-2"
              variant="primary"
              block
              @click="validationForm"
            >
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
        <b-button
          type="submit"
          class="mt-2"
          variant="primary"
          block
          @click="externalFederation('google-ws')"
        >
          Sign in with Google
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          block
          disabled
          @click="externalFederation('okta')"
        >
          Sign in with Okta
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BForm, BButton, BCard,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import RidenLogo from '@/layouts/components/Logo.vue'
import router from '@/router'
import AdminAuth from '@/libs/admin-auth'

export default {
  components: {
    BCard,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BForm,
    BButton,
    RidenLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      username: '',
      // validation rulesimport store from '@/store/index'
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    ...mapActions({ authenticateUser: 'auth/authenticateUser' }),
    externalFederation(provider) {
      const adminAuth = new AdminAuth(this.$root)
      adminAuth.federate(provider)
    },
    async validationForm() {
      const isValid = await this.$refs.loginValidation.validate()
      if (isValid) {
        const { authenticated, user, userData } = await this.authenticateUser({ username: this.username, password: this.password })
        if (authenticated) {
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            router.push('new-password')
          } else {
            this.$ability.update(userData.ability)
            localStorage.setItem('userData', JSON.stringify(userData))
            router.push({ path: '/' })
            // LOGROCKET USER
            window.LogRocket.identify(userData.email)
          }
        } else {
          this.$swal({
            title: 'Error!',
            text: 'Please enter correct username or password',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss'
</style>
